import { useEffect, useState } from "react"
import { ITurnoBody } from "../../../../../Interfaces/auxiliar/ITurno"
import { TurnoService } from "../../../../../services/auxiliar/turnoService"
import { IPanelTurnoInsertar } from "./PanelTurnoInsertar"
import { IResponseApiFluent, codigosRespuesta } from "../../../../../Interfaces/base/IResponse"

export const usePanelTurnoInsertar=(props:IPanelTurnoInsertar)=>{
    const inital:ITurnoBody={
        nombre: "",
        codigo: "",
        horaInicio:undefined,
        horaFin:undefined,
    }
    const [disableForm, setDisableForm] = useState<boolean>(true);
    const [status, setStatus] = useState<codigosRespuesta>(0);
   const [mensaje, setMensaje] = useState<string>("");

    const [loading,setLoading]=useState<boolean>(false)
    const [request,setRequest]=useState<ITurnoBody>(inital)
  
    useEffect(()=>{
        const check = required.every((field) => {
            const value = request[field];
            return value !== null && value !== undefined && value !== "";
          });
        setDisableForm(!check)
    },[request])

    const required: (keyof ITurnoBody)[] = [
        "nombre",
        "codigo",
        "horaInicio"
      ];

    const reset=()=>{
        setMensaje("")
        setRequest(inital)
        setStatus(0)
        props.onDismiss()
    }
    
    const postInsertarTurno=()=>{
        setLoading(true)
        TurnoService.CrearTurno(request).then((res)=>{
            if(res.status==200){
                setStatus(200)
                setMensaje(res.data.mensaje);
                setTimeout(()=>{
                    props.reload?.();
                    reset()
                },3000)
            }else{
                setStatus(500)
            }
            setLoading(false)
           
        }).catch((e)=>{
            if (
                e.response?.data &&
                'type' in e.response.data &&
                'title' in e.response.data &&
                'status' in e.response.data &&
                'instance' in e.response.data &&
                'errors' in e.response.data
              ) {
                const errorResponse = e.response.data as IResponseApiFluent;
                const mensajeError = errorResponse.errors.join('\n');
                setMensaje(mensajeError);
              } else {
                console.log('Error detallado:', e);
                setMensaje("Error Inesperado");
              }
              setStatus(500);
              setLoading(false);
        })
    }
    return {request,setRequest,postInsertarTurno,loading,disableForm,reset,mensaje,status}
}